import { createContext, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom";


const GlobaContext = createContext();
export const useGlobal = () => useContext(GlobaContext);

const GlobalProvider = ({children}) => {

    // Пагінатор
    const [ paginator, setPaginator ] = useState(null);

    // Признак останньої сторінки пігінатора
    const [ showLastPage, setShowLastPage ] = useState(false);

    // Стрічка пошуку/фільтрації
    const [ search, setSearch ] = useState(null);

    // Фільтр локалізації
    const [ localeFilter, setLocaleFilter ] = useState('');

    // Активація фільтра локацій
    const [ localeFilterActive, setLocaleFilterActive ] = useState(false);

    // Елемент таргету
    const [ target, setTarget ] = useState(true);

    // компонент футера
    const [ footerComponent, setFooterComponent ] = useState(null);

    // сигнал футера
    const [ footerSignal, setFooterSignal ] = useState(null);

    // Обраний режим бізнесу
    const [ settingsMode, setSettingsMode ] = useState('general');

    const setPaginatorPage = (pathname, page) => {
        setPaginator((prev)=> ({
            ...prev,
            [pathname] : {
                ...paginator[pathname],
                currentPage : [page]
            }
        })) 
    }

    const g = {
         
        // Стан пагінатора
        paginator           : paginator,
        setPaginator        : setPaginator,
        showLastPage        : showLastPage,
        setShowLastPage     : setShowLastPage,
        setPaginatorPage    : setPaginatorPage,

        footerComponent     : footerComponent,
        setFooterComponent  : setFooterComponent,
        footerSignal        : footerSignal,
        setFooterSignal     : setFooterSignal,
        localeFilter        : localeFilter, 
        setLocaleFilter     : setLocaleFilter, 
        localeFilterActive  : localeFilterActive, 
        setLocaleFilterActive : setLocaleFilterActive, 

        settingsMode        : settingsMode,
        setSettingsMode     : setSettingsMode,

        // Пошук
        search              : search,
        setSearch           : setSearch,
        target              : target,
        setTarget           : setTarget,
        
    }



    return (
        <GlobaContext.Provider value={{g}}>
            {children}
        </GlobaContext.Provider>
    )
}
 
export default GlobalProvider; 